export function getListingObjectCellImageSrc(photo) {
  return photo?.thumb_url || photo?.url || null
}

export function getHasListingObjectCellImage({ failedSrc, src }) {
  return Boolean(src) && src !== failedSrc
}
